// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-input {
  width: 150px;
}

.bg-light.rounded {
  max-width: 824px;
  padding: 35px !important;
  margin: 0 auto !important;
}

.bg-light.rounded .d-flex.justify-content-between > div:first-child {
  text-align: left !important;
}

.bg-light.rounded .d-flex.justify-content-between > div:first-child h4,
.bg-light.rounded .d-flex.justify-content-between > div:first-child h6 {
  text-align: left !important;
}

.form-label {
  font-size: 12px !important;
}

.form-control,
.form-select {
  font-size: 13px !important;
  padding: 6px 12px !important;
}

.card-title {
  font-size: 14px !important;
}

.btn {
  font-size: 13px !important;
}

`, "",{"version":3,"sources":["webpack://./src/Pages/HGO/Dashboard/ReversalIncomingRequest/ReversalIncomingRequest.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":[".date-input {\n  width: 150px;\n}\n\n.bg-light.rounded {\n  max-width: 824px;\n  padding: 35px !important;\n  margin: 0 auto !important;\n}\n\n.bg-light.rounded .d-flex.justify-content-between > div:first-child {\n  text-align: left !important;\n}\n\n.bg-light.rounded .d-flex.justify-content-between > div:first-child h4,\n.bg-light.rounded .d-flex.justify-content-between > div:first-child h6 {\n  text-align: left !important;\n}\n\n.form-label {\n  font-size: 12px !important;\n}\n\n.form-control,\n.form-select {\n  font-size: 13px !important;\n  padding: 6px 12px !important;\n}\n\n.card-title {\n  font-size: 14px !important;\n}\n\n.btn {\n  font-size: 13px !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
